export type BreadcrumbsTranslation = {
  ariaLabel: string;
  details: string;
};

export const breadcrumbsTranslation: BreadcrumbsTranslation = {
  ariaLabel: 'Okruszki nawigacji',
  details: 'Szczegóły',
};
